
import BaseScene from '../scenes/BaseScene';
import Node from './Node';
import Path from './Path';
import PathMovement from './PathMovement';

export default class PathManager {
    private relatedScene: BaseScene;
    private paths: Path[];
    private pathMovements: PathMovement[];

    constructor(scene: BaseScene) {
        this.relatedScene = scene;
        this.paths = [];
        this.pathMovements = [];
    }

    public create() {
        this.paths.forEach((path: Path) => {
            path.create();
        });
    }

    public all(): Path[] {
        return this.paths;
    }

    public allMovements(): PathMovement[] {
        return this.pathMovements;
    }

    public add(node1: Node, node2: Node, additionalPoints: any[]) {
        this.paths.push(
            new Path(this.relatedScene, node1, node2, additionalPoints)
        );
    }

    public createPathMovement(origenNode: Node, destineNode: Node, movementPercentage = 1): PathMovement | null {

        // Check arguments
        const path = this.searchPath(origenNode, destineNode);
        if(!path) return null;

        const totalUnitsToMove = origenNode.calculateUnitsToMove(movementPercentage);
        if(totalUnitsToMove <= 0) return null;

        // Create pathMovement
        const pathMovement = new PathMovement(
            this.relatedScene,
            origenNode,
            destineNode,
            path,
            {'counter': totalUnitsToMove}
        );

        // Store & Destroy on pathManager
        pathMovement.onDestroy = () => {
            this.removePathMovement(pathMovement);
        };
        this.pathMovements.push(pathMovement);

        return pathMovement;
    }

    private removePathMovement(pathMovement: PathMovement): void {
        const index = this.pathMovements.indexOf(pathMovement);
        if (index !== -1) {
            this.pathMovements.splice(index, 1);
        }
    }

    public startPathMovement(origenNode: Node, destineNode: Node, movementPercentage = 1): void {
        const pathMovement = this.createPathMovement(origenNode, destineNode, movementPercentage);
        if(!pathMovement) return;
        pathMovement.execute(); 
    }

    public searchPath(origenNode: Node, destineNode: Node): Path | undefined {
        return this.paths.filter((path: Path) => {
            return (path.origenNode == origenNode && path.destineNode == destineNode)
                || (path.origenNode == destineNode && path.destineNode == origenNode);
        })[0];
    }

    public searchPathMovement(origenNode: Node, destineNode: Node): PathMovement | undefined {
        return this.pathMovements.filter((pathMovement: PathMovement) => {
            return (pathMovement.origenNode == origenNode && pathMovement.destineNode == destineNode)
                || (pathMovement.origenNode == destineNode && pathMovement.destineNode == origenNode);
        })[0];
    }
}